import React, { useState, useEffect } from 'react';

const Actionsforvendorcomponent = (props) => {
  const email = localStorage.getItem('email') || '';
  const vendorKey = email.split('@')[0];

  const getStatusFromProps = () => {
    const participation = props.data.indent.vendors_participation;
    if (participation && participation[vendorKey]) {
      return participation[vendorKey];
    }
    return 'pending';
  };

  const [status, setStatus] = useState(getStatusFromProps());

  useEffect(() => {
    const updatedStatus = getStatusFromProps();
    setStatus(updatedStatus);
  }, [props.data.indent.vendors_participation]);

  const handleAccept = async (e) => {
    e.stopPropagation();
    // const ok = await props.context.componentParent.onClickacceptparticipation(props);
        const ok = await props.context.componentParent.onClickbiddetails(props);

    if (ok !== false) setStatus('accepted');
  };

  const handleDecline = async (e) => {
    e.stopPropagation();
    const ok = await props.context.componentParent.onClickdeclineparticipation(props);
    if (ok !== false) setStatus('declined');
  };

  const handleBidNow = (e) => {
    e.stopPropagation();
    props.context.componentParent.onClickbiddetails(props);
  };
  const indent = props.data.indent;
  const isDisabled =  indent.vendorquotes  && indent.vendorquotes.some(e => e.vendor_email_id === localStorage.getItem("email"));


return (
  <div className={`accept_btn_container ${isDisabled ? "disabled" : ""}`}>
    <button
      onClick={handleAccept}
      title="Approve"
      className="vendor-approve-btn"
      disabled={isDisabled}
    >
      Accept
    </button>
    <button
      onClick={handleDecline}
      title="Decline"
      className="vendor-reject-btn"
      disabled={isDisabled}
    >
      Decline
    </button>
  </div>
);


};

export default Actionsforvendorcomponent;
